// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rscowwmoeycyxmfslhme.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJzY293d21vZXljeXhtZnNsaG1lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE0OTMyNTQsImV4cCI6MjA2NzA2OTI1NH0.qUsm6rt8cPME0Xe8ctUGgXkYufZ8zS-pE0QBh9GLGhQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});